import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7377c256")

_pushScopeId("data-v-7377c256")
const _hoisted_1 = /*#__PURE__*/_createVNode("p", { style: {"text-align":"left","margin-left":"25%"} }, " 睡眠时长 ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("div", {
      class: "chart",
      ref: $setup.setRef
    }, null, 512)
  ], 64 /* STABLE_FRAGMENT */))
})